import classNames from "classnames";
import { forwardRef } from "react";
import { cn } from "utils/cn";

import { Error } from "./Form";

type FormFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  errorMessage?: string;
  label?: string;
  name: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
};

export const TextField = forwardRef<HTMLInputElement, FormFieldProps>(
  (
    {
      errorMessage,
      className,
      label,
      name,
      startAdornment,
      endAdornment,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={classNames("flex flex-col mb-4", className)}>
        {label && (
          <label
            className="text-[#A4A4A4] mb-2 whitespace-pre-line font-inter text-xs"
            htmlFor={name}
          >
            {label}
          </label>
        )}

        <div className="relative flex items-center">
          {startAdornment && (
            <div className="absolute left-3 flex items-center pointer-events-none z-10">
              {startAdornment}
            </div>
          )}
          <input
            {...props}
            name={name}
            ref={ref}
            className={cn(
              "input-gradient w-full h-[35.4px] text-white placeholder-[#A4A4A4] font-normal text-[11px]",
              startAdornment ? "pl-10" : "px-3",
              className,
            )}
          />
          {endAdornment && (
            <div className="absolute right-3 flex items-center">
              {endAdornment}
            </div>
          )}
        </div>

        <div className="h-3">
          {errorMessage && <Error text={errorMessage} />}
        </div>
      </div>
    );
  },
);

TextField.displayName = "TextField";
